import { useCommonDataContext } from "@core/CommonDataContext";
import { FCX } from "@datassential/platform-ui-lib/lib/core/models"
import cn from "classnames";
import { useCallback, useMemo } from "react";
import SelectCategoryBlock from "./SelectCategoryBlock";
import { FILTERS_CATEGORIES_GROUPS } from "@core/models/Category";

const SelectCategories: FCX = ({
    className,
    testId,
}) => {
    const { isLoading, categories } = useCommonDataContext();

    const getCategory = useCallback((categoryId: number) => {
        return categories?.find((category) => category.id === categoryId);
    }, [categories]);

    const categoryBlocks = useMemo(() => {
        return (FILTERS_CATEGORIES_GROUPS)
            .map((categoriesIds, index) => {
                const categoryBlocks = categoriesIds.map((categoryId, cIndex) => {
                    const category = getCategory(categoryId);
                    if (!category?.isEnabled) {
                        return null;
                    }

                    return (
                        <SelectCategoryBlock
                            key={categoryId}
                            category={category}
                            className="SelectCategories__item"
                            testId={`blockSelectCategories_${index}_${cIndex}`}
                        />
                    );
                }).filter((item) => item !== null);

                return categoryBlocks.length > 0 ? <div key={categoriesIds[0]} className="SelectCategories__column">{categoryBlocks}</div> : null;
            }).filter((item) => item !== null);
    }, [getCategory]);

    if (isLoading) {
        return null;
    }
 
    return (
        <div
            className={
                cn(
                    "SelectCategories",
                    className,
                )
            }
            data-testid={testId}
        >
            <div
                className="SelectCategories__title"
                data-testid="textSelectCategories"
            >
                CATEGORIES
            </div>
            <div
                className="SelectCategories__items"
                style={{
                    "--columns-count": categoryBlocks.length,
                } as React.CSSProperties}
                data-testid="blockSelectCategories"
            >
                {categoryBlocks}
            </div>
        </div>
    );
};

export default SelectCategories;